/**
 * Alinhado ao enum backend RoutePointAction (value = primeiro campo JSON).
 * status = segundo campo (rótulo exibido), description = terceiro.
 */
import { DELIVERY_STATUS } from '../Deliveries/statusConfig';

export const ROUTE_POINT_ACTION = {
    DELIVERY: 'DELIVERY',
    COLLECTION: 'COLLECTION',
    PICKUP: 'PICKUP',
    TRANSFER: 'TRANSFER',
};

/** Opções do dropdown: value (API), label (status do enum), description (tooltip). */
export const ROUTE_POINT_ACTION_OPTIONS = [
    {
        value: ROUTE_POINT_ACTION.DELIVERY,
        label: 'ENTREGA',
        description: 'A entrega de um ou mais itens foi realizada.',
    },
    {
        value: ROUTE_POINT_ACTION.COLLECTION,
        label: 'COLETA',
        description: 'Um ou mais itens foram coletados para entrega futura.',
    },
    {
        value: ROUTE_POINT_ACTION.PICKUP,
        label: 'RETIRADA',
        description: 'Um ou mais itens entregues anteriormente foram coletados novamente.',
    },
    {
        value: ROUTE_POINT_ACTION.TRANSFER,
        label: 'TRANSFERÊNCIA',
        description: 'Um ou mais itens foram transportados entre unidades logísticas.',
    },
];

/** Normaliza valor persistido ou legado (COLETA / ENTREGA) para o código do enum. */
export function normalizeRoutePointAction(raw) {
    if (raw == null || raw === '') return ROUTE_POINT_ACTION.DELIVERY;
    const s = String(raw);
    if (s === 'COLETA' || s === ROUTE_POINT_ACTION.COLLECTION) return ROUTE_POINT_ACTION.COLLECTION;
    if (s === 'ENTREGA' || s === ROUTE_POINT_ACTION.DELIVERY) return ROUTE_POINT_ACTION.DELIVERY;
    if (s === ROUTE_POINT_ACTION.PICKUP) return ROUTE_POINT_ACTION.PICKUP;
    if (s === ROUTE_POINT_ACTION.TRANSFER) return ROUTE_POINT_ACTION.TRANSFER;
    return ROUTE_POINT_ACTION.DELIVERY;
}

/**
 * Endereço exibido no cartão conforme a ação (mock com coleta/entrega da entrega).
 * COLETA, RETIRADA e TRANSFERÊNCIA usam o mesmo endereço de coleta; ENTREGA usa o de entrega.
 *
 * @param {string} action - ROUTE_POINT_ACTION.*
 * @param {{ pickupAddress?: string, deliveryAddress?: string }} delivery
 */
export function getAddressForPointAction(action, delivery) {
    const d = delivery || {};
    const pickup = d.pickupAddress || '—';
    const drop = d.deliveryAddress || '—';

    if (action === ROUTE_POINT_ACTION.DELIVERY) {
        return { address: drop, title: 'Endereço de entrega' };
    }

    const titleByPickupAction = {
        [ROUTE_POINT_ACTION.COLLECTION]: 'Endereço de coleta',
        [ROUTE_POINT_ACTION.PICKUP]: 'Endereço (retirada)',
        [ROUTE_POINT_ACTION.TRANSFER]: 'Endereço (transferência)',
    };
    if (titleByPickupAction[action]) {
        return {
            address: pickup,
            title: titleByPickupAction[action],
        };
    }

    return { address: drop, title: 'Endereço' };
}

/**
 * Instruções de entrega/coleta conforme a ação do ponto.
 *
 * @param {string} action - ROUTE_POINT_ACTION.*
 * @param {{ deliveryInstructions?: string, pickupInstructions?: string }|null|undefined} deliveryShape
 * @returns {string}
 */
export function getInstructionsForAction(action, deliveryShape) {
    if (!deliveryShape) return '';
    if (action === ROUTE_POINT_ACTION.DELIVERY) {
        return deliveryShape.deliveryInstructions || '';
    }
    return deliveryShape.pickupInstructions || '';
}

/** Ações cujo sucesso ou falha do motorista mantém a entrega em trânsito. */
export const IN_TRANSIT_POINT_ACTIONS = [
    ROUTE_POINT_ACTION.COLLECTION,
    ROUTE_POINT_ACTION.PICKUP,
    ROUTE_POINT_ACTION.TRANSFER,
];

/**
 * Status de entrega refletido após o motorista concluir o ponto (sucesso ou falha).
 *
 * @param {string} action - ROUTE_POINT_ACTION.*
 * @returns {{ kind: 'in_transit', status: string } | { kind: 'delivery', onSuccess: string, onFailure: string }}
 */
export function getPointActionDeliveryStatusOutcomes(action) {
    const normalized = normalizeRoutePointAction(action);

    if (normalized === ROUTE_POINT_ACTION.DELIVERY) {
        return {
            kind: 'delivery',
            onSuccess: DELIVERY_STATUS.DELIVERED,
            onFailure: DELIVERY_STATUS.DELIVERY_FAILURE,
        };
    }

    return {
        kind: 'in_transit',
        status: DELIVERY_STATUS.IN_TRANSIT,
    };
}
